import { useLocation } from 'react-router-dom'

import { fetchEnvironment } from 'config/environment'
import moment from 'moment'

import { useCallback } from 'modules/core/hooks/useCallback'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track } from 'modules/core/lib/Tracking'

const TIMEOUT_HOURS = 8 // Amount of hours to wait before checking for updates

const LOAD_APP_TIME = moment()

export const useReloadOutdatedApp = () => {
  const { pathname } = useLocation()

  const checkForUpdate = useCallback(async () => {
    const { lastReleaseVersion, releaseVersion } = await fetchEnvironment()

    if (lastReleaseVersion !== releaseVersion) {
      track('Reload outdated app', { from: releaseVersion, to: lastReleaseVersion })
      window.location.reload()
    }
  }, [])

  useEffect(() => {
    const timeNow = moment()

    if (timeNow.diff(LOAD_APP_TIME, 'hours') > TIMEOUT_HOURS) {
      checkForUpdate()
    }
  }, [pathname])
}
